import { Condition } from '@/shared/ui/condition/condition';
import { HeaderActionsBox } from '@/flat-pages/bonuses/ui/styles';
import { BonusRegisterBanner } from '@/flat-pages/bonuses/ui/bonus-register-banner';
import { BonusHeader } from '@/flat-pages/bonuses/ui';

interface PageHeaderSectionProps {
  dataWelcomeAvailable: any;
  isProfileBonusesPage: boolean;
}

export const PageHeaderSection = ({
  dataWelcomeAvailable,
  isProfileBonusesPage,
}: PageHeaderSectionProps) => {
  return (
    <HeaderActionsBox>
      <Condition match={!!dataWelcomeAvailable?.id}>
        <BonusRegisterBanner />
      </Condition>
      <Condition match={!isProfileBonusesPage}>
        <BonusHeader />
      </Condition>
    </HeaderActionsBox>
  );
};
